import React, { useEffect } from 'react';
import classNames from 'classnames';

import * as styles from './index.module.scss';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  title?: React.ReactNode;
  emphasizeTitle?: boolean;
  children?: React.ReactNode;
  buttons?: React.ReactNode;
  closeOnDimmerClick?: boolean;
};
export const Modal: React.FC<Props> = ({
  isOpen,
  onClose,
  emphasizeTitle,
  title,
  children,
  buttons,
  closeOnDimmerClick = true,
}) => {
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && onClose) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEsc);
      return () => document.removeEventListener('keydown', handleEsc);
    }
    return;
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <>
      <div
        className={styles.modalBackdrop}
        onClick={closeOnDimmerClick ? onClose : undefined}
        aria-hidden="true"
        tabIndex={-1}
      />
      <div
        className={styles.modalContainer}
        role="dialog"
        aria-modal="true"
        aria-labelledby={title ? 'modal-title' : undefined}
      >
        {title && (
          <div
            className={classNames(
              styles.modalHeader,
              emphasizeTitle && styles.emphasize,
            )}
            id="modal-title"
          >
            {title}
          </div>
        )}

        <div className={styles.modalContent}>{children}</div>

        <div className={styles.modalActions}>
          <div className={styles.actionsInnerWrapper}>{buttons}</div>
        </div>
      </div>
    </>
  );
};
